import { z } from 'zod';
import { CASE_STATUSES } from '../enums.js';
import { MAX_LABELS_PER_CASE } from './label.js';
import { nonEmptyString, optionalText, paginationSchema, uuidSchema } from './common.js';
export const MAX_CHECKLIST_ITEMS = 500;
export const checklistItemSchema = z.object({
    /** One line: the check is listed as a row while a run is executed. */
    title: nonEmptyString(300, 'Title'),
    /** Light Markdown, like the fields of a test case. */
    expectedResult: optionalText(2000),
    /** The documented case this check covers, when there is one. */
    testCaseId: uuidSchema.nullable().optional(),
});
export const createChecklistSchema = z.object({
    title: nonEmptyString(300, 'Title'),
    description: optionalText(10_000),
    // A checklist lives in a folder of the project, like a test case.
    folderId: uuidSchema.describe('Folder'),
    /** The same lifecycle values a test case has. */
    status: z.enum(CASE_STATUSES).default('active'),
    /** One of the project's environments, or none. */
    environmentId: uuidSchema.nullable().optional(),
    /** One of the project's layers and modules, or neither. */
    layerId: uuidSchema.nullable().optional(),
    moduleId: uuidSchema.nullable().optional(),
    labelIds: z.array(uuidSchema).max(MAX_LABELS_PER_CASE).default([]),
    items: z.array(checklistItemSchema).max(MAX_CHECKLIST_ITEMS).default([]),
});
export const updateChecklistSchema = z
    .object({
    title: nonEmptyString(300, 'Title').optional(),
    description: optionalText(10_000),
    folderId: uuidSchema.optional(),
    status: z.enum(CASE_STATUSES).optional(),
    environmentId: uuidSchema.nullable().optional(),
    layerId: uuidSchema.nullable().optional(),
    moduleId: uuidSchema.nullable().optional(),
    /** When present, the whole label set is replaced. */
    labelIds: z.array(uuidSchema).max(MAX_LABELS_PER_CASE).optional(),
})
    .refine((value) => Object.keys(value).length > 0, { message: 'Nothing to update' });
/** Full replacement of the item collection; array order defines positions. */
export const replaceChecklistItemsSchema = z.object({
    items: z.array(checklistItemSchema).max(MAX_CHECKLIST_ITEMS),
});
export const CHECKLIST_SORT_FIELDS = ['createdAt', 'updatedAt', 'title', 'seqNumber'];
export const listChecklistsSchema = paginationSchema.extend({
    folderId: uuidSchema.optional(),
    includeSubfolders: z.coerce.boolean().default(false),
    status: z.enum(CASE_STATUSES).optional(),
    labelId: uuidSchema.optional(),
    q: z.string().trim().max(200).optional(),
    sort: z.enum(CHECKLIST_SORT_FIELDS).default('seqNumber'),
    order: z.enum(['asc', 'desc']).default('desc'),
});
//# sourceMappingURL=checklist.js.map